import { useTranslation } from 'react-i18next';
import { WifiOff, RefreshCw } from 'lucide-react';
import SEOHead from "../components/SEOHead";

export default function Offline() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#09090B] text-white flex items-center justify-center px-6">
      <SEOHead
        title={t('offline.offline_max_employee')}
        description={t('offline.you_are_currently_offline_please_check_your')}
        url="/offline"
        noIndex
      />
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center">
          <WifiOff className="w-10 h-10 text-zinc-500" />
        </div>
        <h1 className="font-display text-3xl uppercase mb-4">
          {t('offline.title')}
        </h1>
        <p className="text-zinc-400 text-lg leading-relaxed mb-8">
          {t('offline.message')}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-black px-6 py-3 font-bold uppercase tracking-wider text-sm transition-all hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#09090B]"
        >
          <RefreshCw className="w-4 h-4" />
          {t('offline.try_again')}
        </button>
      </div>
    </div>
  );
}
